/**
 * Validates an attacker-controlled `next` URL into a safe same-origin relative
 * path. Returns `/` for any input that's missing, absolute, cross-origin, or
 * malformed — preventing open-redirect attacks via the login `?next=` param.
 */
export function safeRelativePath(path: string | null | undefined, baseOrigin: string): string {
  if (!path) return '/';
  if (!path.startsWith('/')) return '/';
  if (path.includes('\\')) return '/';
  try {
    const url = new URL(path, baseOrigin);
    if (url.origin !== baseOrigin) return '/';
    return url.pathname + url.search + url.hash;
  } catch {
    return '/';
  }
}
